import '../scss/customize.scss';



window.WebFontConfig = {
  google: {
    families: [
      'EB+Garamond:400,600,700',
      'Open+Sans:400,600,700',
      'Work+Sans:500,600',
      'Mulish:600,700',
      'Poppins:400,500,600', 
      'Jost:100,500,700',
      'Roboto:400', 
      'Zen+Kaku+Gothic+New:400,500,700',
      'Noto+Sans+JP:400,500,700,900',
      'Montserrat:100,100i,200i,400,700'
    ]
  },

  typekit: {
    id: 'jyw6wwa'
  },
  
  custom: {
    families: ['YakuHanJP'],
    urls: ['https://cdn.jsdelivr.net/npm/yakuhanjp@3.4.1/dist/css/yakuhanjp.min.css']
  },
  
  active: function () {
    sessionStorage.fonts = true;
  }
};

document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('hamburger-btn');
  const nav = document.getElementById('pc-nav');
  const navLinks = document.querySelectorAll('#pc-nav a');

  if (btn && nav) {
    // ハンバーガーボタンをクリックした時
    btn.addEventListener('click', function() {
      btn.classList.toggle('is-active');
      nav.classList.toggle('is-open');
    });

    // メニュー内のリンクをクリックしたらメニューを閉じる
    navLinks.forEach(link => {
      link.addEventListener('click', function() {
        btn.classList.remove('is-active');
        nav.classList.remove('is-open');
      });
    });
  }

  // --- FAQアコーディオン ---
  const questions = document.querySelectorAll('.qa_block .question');
  
  questions.forEach(question => {
    question.addEventListener('click', function() {
      const parent = this.parentElement; 
      const answer = this.nextElementSibling; 

      parent.classList.toggle('is-open'); 

      if (parent.classList.contains('is-open')) {
        const height = answer.scrollHeight; 
        answer.style.maxHeight = height + 'px';
      } else {
        answer.style.maxHeight = '0px';
      }
    });
  });

  if (typeof Splide !== 'undefined') {
    new Splide('#voice-slider', {
    type       : 'loop',
    autoplay   : true,
    interval   : 4000,
    speed      : 1000,
    arrows     : true,
    pagination : false,
    focus      : 'center',
    updateOnMove: true,
    
    fixedWidth : '700px',  
    gap : '60px',
    
    breakpoints: {
      900: {
        fixedWidth: '262px', 
        gap: '67px',
      }
    }
  }).mount();
  }

const lazyElements = document.querySelectorAll('[data-lazydisp]');

  if (lazyElements.length > 0) {
    lazyElements.forEach(elm => {
      elm.classList.add('lazyhide');
      elm.classList.add('lazyReady');
      setTimeout(() => {
        elm.classList.remove('lazyReady');
      }, 100);
    });

    // 2. 監視ルールの設定
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -10% 0px", 
      threshold: 0
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;
          
          target.classList.remove('lazyhide');
          
          if (target.dataset.lazyAddclass) {
            target.classList.add(target.dataset.lazyAddclass);
          }

          observer.unobserve(target);
        }
      });
    }, observerOptions);

    lazyElements.forEach(elm => observer.observe(elm));
  }

  const bnrCloseBtn = document.querySelector('.fixed-bnr__close');
  const bnrWrap = document.querySelector('.fixed-bnr__wrap');
  if (bnrCloseBtn && bnrWrap) {
    bnrCloseBtn.addEventListener('click', function() {
      bnrWrap.style.transition = 'opacity 0.5s ease, visibility 0.5s';
      bnrWrap.style.opacity = '0';
      bnrWrap.style.visibility = 'hidden';
      bnrWrap.style.pointerEvents = 'none';
      setTimeout(() => { bnrWrap.remove(); }, 500);
    });
  }

});

if (window.location.hash) {
  window.addEventListener('load', function() {
    setTimeout(function() {
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    }, 100); 
  });
}

